import PropTypes from "prop-types";
import React from "react";
import IconButton from "ui/IconButton";
import Icon from "assets/svg/minus.svg";

const IconButtonMinus = (props) => {
  return (
    <IconButton {...props}>
      <Icon />
    </IconButton>
  );
};
IconButtonMinus.propTypes = {
  onClick: PropTypes.func,
};
export default IconButtonMinus;
